/**
 * Rules Modal Component
 *
 * Displays the game rules in a modal overlay.
 * Uses i18n for translated content.
 */

import React from 'react';
import { useTranslation } from '../i18n/index.js';
import './RulesModal.css';

export default function RulesModal({ onClose }) {
  const { t } = useTranslation();

  // Close on overlay click (but not modal content click)
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="rules-modal-overlay" onClick={handleOverlayClick}>
      <div className="rules-modal">
        <button className="rules-close-btn" onClick={onClose} aria-label={t('rules.close')}>
          &times;
        </button>

        <h2>{t('rules.title')}</h2>

        <div className="rules-content">
          <p className="rules-intro">{t('rules.intro')}</p>

          <h3>{t('rules.cardValuesTitle')}</h3>
          <div className="card-values-table">
            <p>{t('rules.cardValues')}</p>
          </div>

          <p>{t('rules.turnStart')}</p>

          <h3>{t('rules.actionsTitle')}</h3>
          <ol className="rules-actions">
            <li>{t('rules.action1')}</li>
            <li>{t('rules.action2')}</li>
            <li>{t('rules.action3')}</li>
            <li>{t('rules.action4')}</li>
          </ol>

          <p>{t('rules.generalAttack')}</p>

          <p>{t('rules.losing')}</p>

          <div className="rules-tip">
            <strong>{t('rules.tipTitle')}:</strong> {t('rules.tip')}
          </div>
        </div>
      </div>
    </div>
  );
}
